import React from 'react';
import styled from 'styled-components';
import ClientTable from 'containers/CompanyContainer/ClientTable';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import CompanyModalWindow from 'containers/CompanyContainer/CompanyModalWindow';
import CompanyPortalWizard from 'containers/CompanyContainer/CompanyPortalWizard';
import PendingClientsTable from 'containers/CompanyContainer/PendingClientsTable';
import TextButton from 'components/Button/TextButton';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { constants } from '../../constants';

import { toArray } from '../../utils/lodashUtils';

import { connect } from 'react-redux';
import * as actions from 'actions';

const MainContainer = styled.div`
    width: 100%;
    background: #fbfbfb;
    padding: 3% 8% 4% 8%;
    box-sizing: border-box;
`;
const ContentContainer = styled.div`
    width: 100%;
    margin: auto;
`;
const TitleWrapper = styled.h3`
    font-size: 30px;
    font-weight: 400;
    letter-spacing: 0.5px;
    color: #7b7474;
`;
const CompanyPageButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;
const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const TableWrapper = styled.div`
    background: white;
    border-radius: 15px;
`;

class ClientsContainer extends React.Component {
    state = {
        openContainer: true,
        isDialogOpen: false,
        type: '',
    };

    render() {
        const { openContainer } = this.state;
        const {
            pendingAccounts: pendingAccountsObj,
            isDialogOpen,
        } = this.props;
        const pendingAccounts = toArray(pendingAccountsObj);

        return (
            <MainContainer>
                <ContentContainer>
                    <HeaderContainer>
                        <TitleWrapper>Clients</TitleWrapper>

                        <TextButton
                            onClick={() =>
                                this.setState({ openContainer: !openContainer })
                            }
                            strong
                            hoverEffect
                            altColor
                        >
                            <FontAwesomeIcon
                                icon={'caret-right'}
                                color={constants.color.grey34}
                                rotation={!openContainer ? 0 : 90}
                                // size="2x"
                                style={{ marginRight: 10 }}
                            />
                            {!openContainer ? 'View Clients' : 'Hide Clients'}
                        </TextButton>
                    </HeaderContainer>

                    {openContainer && (
                        <React.Fragment>
                            <CompanyPageButtonContainer>
                                <CompanyPageButton
                                    children={'Book With Client'}
                                    type={'dark'}
                                    onClick={() =>
                                        this.props.handleDialogStatusChange({
                                            open: !isDialogOpen,
                                            type: 'bookWithClient',
                                            step: 0,
                                        })
                                    }
                                />
                                <CompanyPageButton
                                    children={'Add New Client'}
                                    type={'light'}
                                    onClick={() => {
                                        this.props.saveTempBookingData({
                                            bookingData: null,
                                        });
                                        this.props.handleDialogStatusChange({
                                            open: !isDialogOpen,
                                            type: 'addClient',
                                            step: 0,
                                        });
                                    }}
                                />
                            </CompanyPageButtonContainer>
                        </React.Fragment>
                    )}

                    {isDialogOpen && (
                        <CompanyModalWindow
                            open={isDialogOpen}
                            children={<CompanyPortalWizard />}
                            onClose={() =>
                                this.props.handleDialogStatusChange({
                                    open: false,
                                    type: null,
                                    step: null,
                                })
                            }
                        />
                    )}

                    {openContainer && (
                        <TableWrapper style={{ marginTop: 30 }}>
                            {/*
                            <ClientTable buttonText="Request booking"/>
                        */}
                            {pendingAccounts && pendingAccounts.length > 0 && (
                                <PendingClientsTable
                                    pendingAccounts={pendingAccounts}
                                />
                            )}
                            {(!pendingAccounts ||
                                (pendingAccounts &&
                                    pendingAccounts.length === 0)) && (
                                <p>
                                    There are currently no client accounts
                                    awaiting activation.
                                </p>
                            )}
                        </TableWrapper>
                    )}
                </ContentContainer>
            </MainContainer>
        );
    }
}

const mapStateToProps = ({ company }) => ({
    isDialogOpen: company.isDialogOpen,
});

export default connect(
    mapStateToProps,
    actions,
)(ClientsContainer);



// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/ClientsContainer.jsx